export enum ReflectionTypeEnum {
  InformalStudent = 'informal_student',
  InformalTeacher = 'informal_teacher',
  FormalStudent = 'formal_student',
  FormalTeacher = 'formal_teacher',
}
